import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";
import { FileText, Users, MessageSquare } from "lucide-react";
import { WizardData } from "../SignatureRequestWizard";

interface ReviewStepProps {
  wizardData: WizardData;
}

export default function ReviewStep({ wizardData }: ReviewStepProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-semibold mb-2">Review & Send</h3>
        <p className="text-sm text-muted-foreground">
          Review all details before sending the signature request
        </p>
      </div>

      <div className="space-y-4">
        {/* Document */}
        <Card className="p-4">
          <div className="flex items-start gap-3">
            <FileText className="w-5 h-5 text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <div className="font-medium mb-1">Document</div>
              <div className="text-sm text-muted-foreground">
                Document ID: {wizardData.selectedDocumentId.slice(0, 8)}...
              </div>
            </div>
          </div>
        </Card>

        {/* Signers */}
        <Card className="p-4">
          <div className="flex items-start gap-3">
            <Users className="w-5 h-5 text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <div className="font-medium mb-2">
                Signers ({wizardData.signers.length})
              </div>
              <div className="space-y-2">
                {wizardData.signers.map((signer, idx) => (
                  <div key={`${signer.email}-${idx}`} className="flex items-center gap-2 text-sm">
                    <span className="font-medium">{idx + 1}.</span>
                    <span>{signer.name}</span>
                    <span className="text-muted-foreground">({signer.email})</span>
                    <Badge variant="secondary" className="text-xs">
                      {signer.role?.replace(/_/g, ' ')}
                    </Badge>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Card>

        {/* Message */}
        {wizardData.message && (
          <Card className="p-4">
            <div className="flex items-start gap-3">
              <MessageSquare className="w-5 h-5 text-muted-foreground mt-0.5" />
              <div className="flex-1">
                <div className="font-medium mb-1">Custom Message</div>
                <div className="text-sm text-muted-foreground whitespace-pre-wrap">
                  {wizardData.message}
                </div>
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
}
